
import React from "react";

const VideoGridLoading: React.FC = () => {
  return (
    <div className="py-24 text-center">
      <div className="w-8 h-8 rounded-full border-2 border-primary/30 border-t-primary animate-spin mx-auto mb-4"></div>
      <p className="text-muted-foreground">Loading works...</p>
    </div>
  );
};

export default VideoGridLoading;
